module.exports = __webpack_public_path__ + "@/assets/img/earth.0e77a639.svg";